<template>
  <div class="container">
    <div class="bg" @click="knowMore"></div>
    <div class="steps">
      <p class="applyText">
        工作室是开发者与其他志趣相投的开发者或玩家形成自己的组织的一种方式，创建或者加入工作室，与更多志同道合的人一起玩！还可以获得工作室专属权益。
      </p>
      <span class="applyTitle">申请条件</span>
      <div class="step-wrap">
        <div class="step">
          <div class="icon icon-time"></div>
          <p>注册时间>7天</p>
        </div>
        <div class="step">
          <div class="icon icon-products"></div>
          <p>公开作品数>3个</p>
        </div>
        <div class="step">
          <div class="icon icon-developer"></div>
          <p>已成为认证开发者</p>
        </div>
      </div>
    </div>
    <van-button
      type="primary"
      @click="handleBtnClick"
      :class="{ disabled: cannotApply }"
      :disabled="isAppling"
      >{{ btnText }}</van-button
    >
  </div>
</template>

<script>
import { checkStudioRegisterStatus } from '@/api/studio';
export default {
  data() {
    return {
      is_developer_limit: 0,
      is_day_limit: 0,
      is_artist_limit: 0,
      isAppling: false,
      btnText: '创建工作室',
    };
  },
  mounted() {
    console.log('mounted');
    checkStudioRegisterStatus({ json: 1 }).then(res => {
      let { data } = res;
      this.is_developer_limit = data.is_developer_limit;
      this.is_day_limit = data.is_day_limit;
      this.is_artist_limit = data.is_artist_limit;
      this.isAppling = !!data.is_in_approve;
      if (this.isAppling) {
        this.btnText = '注册审核中';
      }
    });
  },
  computed: {
    cannotApply: function () {
      return !(
        this.is_developer_limit &&
        this.is_day_limit &&
        this.is_artist_limit
      );
    },
  },
  methods: {
    handleBtnClick() {
      //创建工作室点击埋点
      this.$log('create_studio_click', 85440, { v7: 2 });
      if (this.cannotApply) {
        if (!this.is_day_limit) {
          this.$toast.fail('您当前注册天数少于7天哦~');
        } else if (!this.is_artist_limit) {
          this.$toast.fail('公开作品数不得少于3个');
        } else {
          this.$toast.fail('请先注册成为开发者');
        }
      } else {
        this.$router.push({ name: 'creatorForm' });
      }
    },
    knowMore() {
      window.open('https://dev-wiki.mini1.cn/wiki/695.html?id=695', '_blank');
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  padding: 0;
  position: absolute;
  left: 0;
  top: 80px;
  background: #fff;
  height: calc(100vh - 80px);
}
.bg {
  width: 100vw;
  height: 120px;
  background: url('../../../assets/images/creatorBg.png') 0 0 no-repeat;
  background-size: 100vw 120px;
  cursor: pointer;
}
.steps {
  padding: 72px 44px 27px;
  text-align: center;
  .applyText {
    width: 662px;
    height: 108px;
    font-size: 24px;
    line-height: 36px;
  }
  p {
    font-size: 16px;
    line-height: 26px;
    text-align: center;
  }
  .applyTitle {
    display: inline-block;
    padding: 0 36px;
    position: relative;
    font-size: 40px;
    line-height: 52px;
    color: #323232;
    margin: 140px auto 88px;
    &::before,
    &::after {
      display: block;
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      width: 48px;
      height: 20px;
      background: url('../../../assets/images/title_fix.svg') 0 0 no-repeat;
      background-size: 48px 20px;
    }
    &::before {
      left: -72px;
    }
    &::after {
      right: -72px;
      transform: rotate(180deg);
    }
  }
  .step-wrap {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 142px;
    width: 662px;
    .step {
      width: 220px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      .icon {
        width: 120px;
        height: 120px;
        background-position: 0 0;
        background-repeat: no-repeat;
        background-size: 120px;
        &.icon-time {
          background-image: url('../../../assets/images/icon-time.svg');
        }
        &.icon-products {
          background-image: url('../../../assets/images/icon-products.svg');
        }
        &.icon-developer {
          background-image: url('../../../assets/images/icon-developer.svg');
        }
      }
      p {
        margin-top: 24px;
        color: #81818f;
        font-size: 24px;
        line-height: 32px;
      }
    }
  }
}
.van-button {
  display: block;
  width: 528px;
  height: 70px;
  margin: auto;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 60px;
  font-size: 28px;
  border-radius: 8px;
  &.disabled {
    opacity: 0.6;
  }
}
</style>
